import { OrganizationType } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<OrganizationType>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const getOrgTypesReducer = createReducer<State, Actions>(initialState, {
  [actions.getOrgTypes.request.type]: actionsHandlers.handleGetManyRequest,
  [actions.getOrgTypes.success.type]: actionsHandlers.handleGetManySuccess,
  [actions.getOrgTypes.failure.type]: actionsHandlers.handleGetManyFailure,
  [actions.getOrgTypes.reset.type]: actionsHandlers.handleGetManyReset,
});

export default getOrgTypesReducer;
